import { Params } from '@angular/router';
import isEmpty from 'lodash-es/isEmpty';

import { isNullOrUndefined } from '@app/util/util';
import { HotelRoom } from '@hotels/hotel-results/entities/hotel-search.payload';
import { Room } from '@shared/base-search-bar/entities/room.entities';
import { HotelReservation, ReservedRoom } from '@booking/entities/hotel-validation.response';

export const ROOM_SEPARATOR = '-';
export const GUEST_SEPARATOR = '_';
export const ONE_DAY = 1000 * 60 * 60 * 24;
export const ONE_NIGHT = 'HOTELS_MODULE.RESULT_HOTELS.NIGHT';
export const MORE_NIGHTS = 'HOTELS_MODULE.RESULT_HOTELS.NIGHTS';
export const ONE_GUEST = 'HOTELS_MODULE.HOME.GUEST';
export const MORE_GUEST = 'HOTELS_MODULE.HOME.GUESTS';
export const PRICE_TO_NIGHT = 'HOTELS_MODULE.RESULT_HOTELS.PRICE_TO_NIGHT';
export const PRICE_TO_NIGHTS = 'HOTELS_MODULE.RESULT_HOTELS.PRICE_TO_NIGHTS';
export const PRICE_TO_NIGHT_PACKAGE_HOTEL = 'PACKAGES_MODULES.PACKAGES_RESULT_MODULE.HOTEL_RESULTS.PRICE_TO_NIGHT';
export const PRICE_TO_NIGHTS_PACKAGE_HOTEL = 'PACKAGES_MODULES.PACKAGES_RESULT_MODULE.HOTEL_RESULTS.PRICE_TO_NIGHTS';

export function guestTotalNumber(params: Params): number {
  const rooms = params['rooms'];
  let total = 0;
  rooms.split(ROOM_SEPARATOR).forEach(room => {
    const guestsNumber = room.split(GUEST_SEPARATOR);
    total+= (parseInt(guestsNumber[0]) + parseInt(guestsNumber[1]))
  })
  return total;
}

export function hotelReservationGuestNumber(reservation: HotelReservation): number {
  let guestNumber = 0;
  reservation.Rooms.forEach((room: ReservedRoom) => {
    guestNumber += room.Adults + room.Children;
  });
  return guestNumber;
}

export function totalRoomsNumber(params: Params): number {
  const rooms = params['rooms'];
  return rooms ? rooms.split(ROOM_SEPARATOR).length : 0;
}

export function validChildrenAges(rooms: Room[]): boolean {
  return rooms.every(room => {
    const ages = (room.childrenAges || []).filter(age => !isNullOrUndefined(age));
    return room.CHILDREN > 0 ? !isEmpty(ages) && ages.length === room.CHILDREN : !isNullOrUndefined(ages);
  });
}

export function totalNights(checkoutDate: string, checkinDate: string): number {
  const checkOutDate = new Date(checkoutDate).getTime();
  const checkInDate = new Date(checkinDate).getTime();
  const difference = checkOutDate - checkInDate;
  return Math.round(difference / ONE_DAY);
}

export function mapPayloadHotelRooms(expression: string): HotelRoom[] {
  let rooms = [];
  try {
    expression.split('-').forEach(room => {
      const specs = room.split('_');
      const Adults = Number(specs[0]);
      const Children = Number(specs[1]);
      const ChildrenAges = [];
      if (Children > 0) {
        specs.forEach((data, i) => {
          if (i > 1) ChildrenAges.push(Number(data));
        });
      }
      rooms.push({
        Adults,
        Children,
        ChildrenAges
      });
    });
  } catch (e) {
    rooms = [];
  }
  return rooms;
}

export function nightsLabel(nights: number): string {
  return nights > 1 ? MORE_NIGHTS : ONE_NIGHT;
}

export function guestLabel(guest: number): string {
  return guest > 1 ? MORE_GUEST : ONE_GUEST;
}

export function priceToNightsLabel(nights: number): string {
  return nights > 1 ? PRICE_TO_NIGHTS : PRICE_TO_NIGHT;
}

export function priceToNightsPackageLabel(nights: number): string {
  return nights > 1 ? PRICE_TO_NIGHTS_PACKAGE_HOTEL : PRICE_TO_NIGHT_PACKAGE_HOTEL;
}
